import { render, staticRenderFns } from "./Businesstype.vue?vue&type=template&id=843c9e9e&scoped=true&"
import script from "./Businesstype.vue?vue&type=script&lang=js&"
export * from "./Businesstype.vue?vue&type=script&lang=js&"
import style0 from "./Businesstype.vue?vue&type=style&index=0&id=843c9e9e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "843c9e9e",
  null
  
)

export default component.exports